import { EnvironmentContext } from "components/Environment/EnvironmentContext";
import Box from "ds/components/Box";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";
import DownloadFileButton from "views/Account/Context/MountedFiles/ListItem/Download";

import { showMountedFilesFormDrawer } from "../../MountedFileDrawer/MountedFilesFormDrawer";
import { showDeleteConfirmation } from "../../VariableDeleteConfirmation/VariableDeleteConfirmation";
import { VariableCellComponentProps } from "./types";

const MountedFilesActionsCell = ({ variable: file, context }: VariableCellComponentProps) => {
  const { onDelete, onUpdate, canDeleteVariables, canCreateAndEditVariables } =
    useTypedContext(EnvironmentContext);
  const canBeEdited = !(file.runtime || context);

  const hasEditAction =
    canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasOverrideAction =
    !canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasDeleteAction =
    canBeEdited && (canDeleteVariables.result || !!canDeleteVariables.message);

  // Return null if no actions are available
  if (!hasEditAction && !hasOverrideAction && !hasDeleteAction) {
    return null;
  }

  return (
    <Box>
      <DropdownMenuEllipsis tooltip="Environment variable actions">
        {hasEditAction && (
          <>
            <DropdownMenuItem
              isDisabled={!canCreateAndEditVariables.result}
              tooltip={canCreateAndEditVariables.message}
              onAction={() =>
                showMountedFilesFormDrawer({
                  id: file.id,
                  onSubmit: onUpdate,
                  file,
                })
              }
            >
              Edit file
            </DropdownMenuItem>
            {!file.writeOnly && file.value && (
              <DownloadFileButton fileName={file.id} href={file.value} />
            )}
          </>
        )}
        {hasOverrideAction && (
          <>
            <DropdownMenuItem
              isDisabled={!canCreateAndEditVariables.result}
              tooltip={canCreateAndEditVariables.message}
              onAction={() =>
                showMountedFilesFormDrawer({
                  id: file.id,
                  onSubmit: onUpdate,
                  file,
                })
              }
            >
              Override
            </DropdownMenuItem>
            {!file.writeOnly && file.value && (
              <DownloadFileButton fileName={file.id} href={file.value} />
            )}
          </>
        )}
        {hasDeleteAction && (
          <DropdownMenuItem
            isDisabled={!canDeleteVariables.result}
            tooltip={canDeleteVariables.message}
            onAction={() => showDeleteConfirmation({ id: file.id, onDelete })}
            danger
          >
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </Box>
  );
};

export default MountedFilesActionsCell;
